export default {
  name: 'misc.situation',
  key: 'situation',
  attributes: {
    awakening: {
      key: 'awakening',
      name: 'entity.orbitalRuin.situation.awakening',
    },
    tech: {
      key: 'tech',
      name: 'entity.orbitalRuin.situation.tech',
    },
    calamity: {
      key: 'calamity',
      name: 'entity.orbitalRuin.situation.calamity',
    },
    secret: {
      key: 'secret',
      name: 'entity.orbitalRuin.situation.secret',
    },
    interlopers: {
      key: 'interlopers',
      name: 'entity.orbitalRuin.situation.interlopers',
    },
  },
};
